package app.nestbridge.domain.identity.service

import app.nestbridge.domain.identity.api.ProfessionalProfileApiClient
import app.nestbridge.domain.identity.model.ProfessionalProfile
import me.tatarka.inject.annotations.Inject
import software.amazon.lastmile.kotlin.inject.anvil.AppScope
import software.amazon.lastmile.kotlin.inject.anvil.ContributesBinding
import software.amazon.lastmile.kotlin.inject.anvil.SingleIn

@SingleIn(AppScope::class)
@ContributesBinding(AppScope::class, boundType = ProfessionalProfileService::class)
@Inject
class DefaultProfessionalProfileService(
    private val apiClient: ProfessionalProfileApiClient,
) : ProfessionalProfileService {

    override suspend fun getCurrent(): ProfessionalProfile? = apiClient.fetchCurrent()?.toDomain()

    override suspend fun save(profile: ProfessionalProfile): ProfessionalProfile =
        apiClient.save(profile.toDto()).toDomain()
}
